<div [ngClass]="'form-editor'">
    <dx-tag-box ngDefaultControl [attr.id]="'input-' + element.ElementID" [acceptCustomValue]="true" applyValueMode="useButtons" displayExpr="DisplayName"
                [items]="sortedItems" [value]="selectedItems" [multiline]="true" [disabled]="inputFormGroup.get('value')?.disabled"
                [showClearButton]="true" [showSelectionControls]="true" valueExpr="Value" (onValueChanged)="changeComboBoxValue($event)"
                [(isValid)]="renderingInformation.validationInformation.valid"
                [(validationError)]="renderingInformation.validationInformation.validationMessage"
                 [placeholder]="element.NullText ?? ''"></dx-tag-box>
</div>
